// src/components/Dashboard/PaCards.jsx
//
// Tarjetas tipo perfil, una por P.A (foto o iniciales, nombre, correo y sus
// números). Tocar una filtra la lista; tocarla otra vez quita el filtro.
// La usan Reclamos (ClaimRecordList) y Comisiones por cheque (ClaimsDirectory).
import React from 'react';
import './PaCards.css';

const initialsOf = name => name.split(/\s+/).filter(Boolean).slice(0, 2).map(part => part[0]).join('').toUpperCase();

// items: [{ name, profile, active, stats: [{ label, value }] }]
const PaCards = ({ items, selected = 'all', onSelect, title, clearLabel, ariaLabel, id }) => (
  <div className="crl-pa-panel" id={id}>
    {title && (
      <div className="crl-pa-head">
        <h3>{title}</h3>
        {selected !== 'all' && clearLabel && <button type="button" className="crl-pa-clear" onClick={() => onSelect('all')}>{clearLabel}</button>}
      </div>
    )}
    <div className="crl-pa-grid" role="group" aria-label={ariaLabel}>
      {items.map(({ name, profile, active, stats }) => {
        const isSelected = selected === name;
        return (
          <button key={name} type="button" className={`crl-pa-card ${isSelected ? 'is-selected' : ''}`} aria-pressed={isSelected} onClick={() => onSelect(isSelected ? 'all' : name)}>
            <span className="crl-pa-avatar" aria-hidden="true">
              {profile?.photoDataUrl ? <img src={profile.photoDataUrl} alt="" /> : initialsOf(name)}
              {active && <span className="crl-pa-dot" />}
            </span>
            <span className="crl-pa-name">{name}</span>
            <span className="crl-pa-email">{profile?.email || (profile?.license ? `License ${profile.license}` : ' ')}</span>
            <span className="crl-pa-stats" style={{ gridTemplateColumns: `repeat(${stats.length}, minmax(0, 1fr))` }}>
              {stats.map(stat => <span key={stat.label}><small>{stat.label}</small><strong>{stat.value}</strong></span>)}
            </span>
          </button>
        );
      })}
    </div>
  </div>
);

export default PaCards;
